import Typography from '@mui/material/Typography';
import styled from '@mui/material/styles/styled';
import { Button } from '@/components/ui/buttons/Button/Button';

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 1.94rem;

  ${({ theme }) => theme.breakpoints.down('md')} {
    gap: 1.25rem;
  }
`;

export const Title = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Options = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DividerText = styled(Typography)`
  margin: 0 1rem;
`;

export const AdaptiveButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    height: 2.5rem;
  }
`;
